"use strict";

define('rs/form/attachment.view',['vertebrae'], function (Vertebrae) {
  var AttachmentView = Vertebrae.View.extend({
    watchDelegateProperties: function watchDelegateProperties() {
      this.listenTo(this.getDelegate(), "change:text", this.textDidChange.proxy(this));
      this.listenTo(this.getDelegate(), "change:value", this.updateAttachmentCompletedState.proxy(this));
    },
    textDidChange: function textDidChange() {
      this.setTextOnElement(this.getDelegate().getText());
    },
    setTextOnElement: function setTextOnElement(value) {
      this.$('.attachment-text span').text(value);
    },
    show: function show() {
      return this.$el.show();
    },
    unload: function unload() {
      this.$el.remove();
    },
    updateAttachmentCompletedState: function updateAttachmentCompletedState() {
      var delegate = this.getDelegate(),
        value = delegate.getValue();
      if (value.length) {
        this.$el.addClass("completed");
      } else {
        this.$el.removeClass("completed");
      }
    },
    markAttachmentCompleted: function markAttachmentCompleted() {
      this.$el.addClass("completed");
    },
    refresh: function refresh() {},
    hide: function hide() {
      return this.$el.hide();
    }
  });
  return AttachmentView;
});

